import { render, staticRenderFns } from "./CreateIdpDialog.vue?vue&type=template&id=5c2372fc&scoped=true&"
import script from "@/components/curriculum/CreateIdpDialog.ts?vue&type=script&lang=ts&"
export * from "@/components/curriculum/CreateIdpDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/components/curriculum/create-idp-dialog.scss?vue&type=style&index=0&id=5c2372fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2372fc",
  null
  
)

export default component.exports